import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import './search.css';
import './healerFrame.css';
import Dropdown from '../../dropdown/Dropdown';
import HealerModal from './healerModal';

const Healers = ({ data, getHealersWithFilter, setHealers, range, setRange, getMarkers, selectedHealerId, setSelectedHealerId }) => {
	const navigate = useNavigate();
	const [expandedTicket, setExpandedTicket] = useState(false);
	const [healerState, setHealerState] = useState({});
	const [reviewModal, setReviewModal] = useState(false);
	const [healersWithRatings, setHealersWithRatings] = useState([]);

	// Fetch ratings for healers
	useEffect(() => {
		const fetchRatings = async () => {
			if (data.healers && data.healers.length > 0) {
				const healersWithRatingsData = await Promise.all(
					data.healers.map(async (healer) => {
						try {
							const reviewsResponse = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/review/${healer.id}`);
							const reviews = reviewsResponse.data;
							const avgRating = reviews.length > 0
								? reviews.reduce((acc, review) => acc + review.rating, 0) / reviews.length
								: 0;

							return {
								...healer,
								rating: Math.round(avgRating * 10) / 10, // Round to 1 decimal place
								reviewsCount: reviews.length
							};
						} catch (error) {
							console.error(`Error fetching reviews for healer ${healer.id}:`, error);
							return {
								...healer,
								rating: 0,
								reviewsCount: 0
							};
						}
					})
				);
				setHealersWithRatings(healersWithRatingsData);
			}
		};

		fetchRatings();
	}, [data.healers]);

	useEffect(() => { }, [data.currMarkers, range]);

	// Auto-open healer info modal for selected healer from URL
	useEffect(() => {
		if (selectedHealerId && healersWithRatings && healersWithRatings.length > 0) {
			const selectedHealer = healersWithRatings.find(h => h.id === selectedHealerId);
			if (selectedHealer) {
				setHealerState(selectedHealer);
				setExpandedTicket(true);
				// Clear the selected healer ID after opening modal
				setSelectedHealerId(null);
			}
		}
	}, [selectedHealerId, healersWithRatings, setSelectedHealerId]);

	const handleRange = (range) => {
		getHealersWithFilter({ range: range });
	};



	const handleCloseModals = () => {
		setExpandedTicket(false);
		setReviewModal(false);
	};

	const renderStars = (rating) => {
		const stars = [];
		const fullStars = Math.floor(rating);
		const hasHalfStar = rating % 1 !== 0;

		for (let i = 0; i < 5; i++) {
			if (i < fullStars) {
				stars.push(<span key={i} className="star">★</span>);
			} else if (i === fullStars && hasHalfStar) {
				stars.push(<span key={i} className="star">☆</span>);
			} else {
				stars.push(<span key={i} className="star empty">☆</span>);
			}
		}
		return stars;
	};

	console.log(healersWithRatings);
	return (
		<div>
			{(() => {
				if (expandedTicket && healerState) {
					return (
						<HealerModal
							healerState={healerState}
							setExpandedTicket={setExpandedTicket}
							reviewModal={reviewModal}
							setReviewModal={setReviewModal}
							onClose={handleCloseModals}
						/>
					);
				}
			})()}
			<div className="top_left">

				<div className="users">
					{
						healersWithRatings.length > 0 ? healersWithRatings.map((healer) => (
							<li key={healer.id}>
								<div className="healer">
									<div className="healerHeader">
										<div className="healerTop">
											<p>{healer.firstname} {healer.lastname}</p>
											<div className='icons'>
												<button
													className="icon"
													onClick={(e) => {
														e.stopPropagation();
														navigate(`/book/${healer.id}`);
													}}
													title="Book Appointment"
												>
													<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
														<rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
														<line x1="16" y1="2" x2="16" y2="6"></line>
														<line x1="8" y1="2" x2="8" y2="6"></line>
														<line x1="3" y1="10" x2="21" y2="10"></line>
													</svg>
												</button>
											</div>
										</div>

										{/* Rating Display moved under name */}
										<div className="healerRating">
											<div className="stars">
												{renderStars(healer.rating)}
											</div>
											<div className="rating-text">
												{healer.rating > 0 ? `${healer.rating} (${healer.reviewsCount} reviews)` : 'No reviews yet'}
											</div>
										</div>
									</div>

									<div className="healerServices">
										<div className="healerMiddle">
											{healer.services ? (
												healer.services.split(',').slice(0, 3).map((service, index) => (
													<span key={index} className="serviceTag">
														{service.trim()}
													</span>
												))
											) : (
												<span className="serviceTag">No services listed</span>
											)}
											{healer.services && healer.services.split(',').length > 3 && (
												<span className="serviceTag">+{healer.services.split(',').length - 3} more</span>
											)}
										</div>
									</div>

									<div className="healerContent">
										<div className="healerBottom">
											{healer.description || 'No description available'}
										</div>
									</div>

									<div
										className="healerModalButton"
										onClick={() => {
											setHealerState(healer);
											setExpandedTicket(!expandedTicket);
										}}
									/>
								</div>
							</li>
						)) : <div className="loaderContainer"><div className="loader"></div></div>
					}
				</div>
			</div>
		</div>
	);
}

export default Healers;
